define.alias("shared/components/shared/post/profile-selector/unavailable-profile", "media/components/shared/post/profile-selector/unavailable-profile/index");